import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { PartnerPaths } from "Partner/Routes/Routing";
import { MailOutline, Person, Phone } from "@mui/icons-material";
import { Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router";
import { OrderInfoCard, type OrderInfoItem } from "./OrderInfoCard";

type PartnerInfoTileProps = {
	order?: OrderDetailResponseDto;
};

export function PartnerInfoTile({ order }: PartnerInfoTileProps) {
	const navigate = useNavigate();

	if (!order?.partner) return null;

	const { partner } = order;

	const handleDoubleClick = () => {
		if (partner.id) {
			navigate(PartnerPaths.Detail.path(partner.id));
		}
	};

	const items: OrderInfoItem[] = [
		{
			icon: <Phone fontSize="small" />,
			label: "Phone",
			value: partner.phone,
			show: !!partner.phone,
		},
		{
			icon: <MailOutline fontSize="small" />,
			label: "Email",
			value: partner.email,
			show: !!partner.email,
		},
	];

	return (
		<Tooltip title="Double-click to view partner details" placement="top" arrow>
			<Box onDoubleClick={handleDoubleClick} sx={{ cursor: "pointer" }}>
				<OrderInfoCard
					title="Partner"
					titleIcon={<Person fontSize="small" />}
					mainValue={partner.fullName}
					items={items}
				/>
			</Box>
		</Tooltip>
	);
}
